import React from 'react';
import { CmsButton } from '../../types/contentstack';
import { CmsButtonLink } from '../CmsButtonLink/CmsButtonLink';

type ButtonItem = CmsButton & { _metadata?: { uid: string } };

interface CmsSkinnyRichTextLightBlueData {
  name?: string;
  component?: string;
  body?: string;
  media?: string | null;
  media_position?: string;
  buttons?: ButtonItem[];
  _metadata?: { uid: string };
}

interface CmsSkinnyRichTextLightBlueProps {
  data: CmsSkinnyRichTextLightBlueData;
}

export const CmsSkinnyRichTextLightBlue: React.FC<CmsSkinnyRichTextLightBlueProps> = ({ data }) => {
  const buttons = data.buttons ?? [];

  return (
    <div className="flex justify-center items-center w-full bg-blue-0 py-600">
      <div className="flex flex-col items-center gap-150 max-w-[628px] px-100">
        {data.name && (
          <h2
            className="text-heading-300 font-bold leading-heading text-center text-gray-925 m-0"
            style={{
              letterSpacing: '-1.44px',
              fontFeatureSettings: "'liga' off",
            }}
          >
            {data.name}
          </h2>
        )}

        {data.body && (
          <div
            className="text-body-125 font-medium leading-body text-center text-gray-925 [&>p]:m-0"
            style={{ fontFeatureSettings: "'liga' off" }}
            dangerouslySetInnerHTML={{ __html: data.body }}
          />
        )}

        {buttons.length > 0 && (
          <div className="flex justify-center items-center gap-100 mt-100">
            {buttons.map((button) => {
              const isFilled = button.variant === 'filled';

              return (
                <CmsButtonLink
                  key={button._metadata?.uid ?? button.text}
                  text={button.text}
                  url={button.url}
                  external={button.external}
                  icon={button.icon}
                  icon_position={button.icon_position}
                  className={`flex items-center justify-center rounded-200 no-underline cursor-pointer gap-50 ${
                    isFilled
                      ? 'bg-blue-800 text-white'
                      : 'bg-transparent text-blue-800 border-2 border-blue-800'
                  }`}
                  style={{
                    height: '64px',
                    minWidth: '40px',
                    minHeight: '40px',
                    padding: '20px 24px',
                    fontSize: '20px',
                    fontWeight: 600,
                    lineHeight: '112.5%',
                    textAlign: 'center',
                    fontFeatureSettings: "'liga' off",
                  }}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CmsSkinnyRichTextLightBlue;
